module.exports = "<label class=\"label sn-label label-status label-response {{color}}\">\n  <ng-content></ng-content>\n  <span>{{ text }}</span>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/sn-label/sn-label.html
// module id = ./shared/components/common/sn-label/sn-label.html
// module chunks = 0